<template>
    <InputNullableFloat
        v-model="computedValue"
        posttext="km"
        icon=""
    />
</template>
<script lang="ts" setup>
/**
 * Wrapper for InputNullableFloat so we can convert meters to km in the input field.
 *
 * This will convert the modelValue from meters to kilometers when reading it,
 * and from kilometers to meters when writing it back.
 */
import { InputNullableFloat } from '@/components';
import type { IEditorComponent } from '@/objects/gui';
import { computed, ref } from 'vue';

const inputInstance = ref<InstanceType<typeof InputNullableFloat> | null>(null);

const computedValue = defineModel<number | null>({
    get: (value) => (value !== null ? value! / 1000 : null) ?? null,
    set: (value) => (value = value !== null ? value * 1000 : null),
    required: true,
});

defineExpose<IEditorComponent>({ focus: () => inputInstance.value?.focus(), validateMessage: ref(null) });
</script>
